<template>
  <div class="block-chain-contract">
    <action-bar>
      <search v-model="inputContent" placeholder="请输入合约名称" @onSearch="handleSearch"></search>
      <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="list"
      :first-table-col="firstTableCol"
      :operator="operator"
      :operate-col="operateCol"
      :show-edit="true"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="status" slot-scope="{ param }">
        <span class="vote-status" :class="param.row.MultiSignStatus | transStatusClass">{{
          param.row.MultiSignStatus | transStatus($constants.EMPTY)
        }}</span>
      </template>
    </normal-table>
    <deploy-contract ref="deployContracts" @update:list="handleRefresh()"></deploy-contract>
    <update-contract ref="updateDialog" @update:list="handleRefresh()"></update-contract>
    <edit-contract ref="editContract" @update:list="handleRefresh()"></edit-contract>
    <contract-detail ref="contractDetail" @update:list="handleRefresh()"></contract-detail>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import deployContract from './deployContract'
import updateContract from './updateContract'
import editContract from './editContract'
import contractDetail from './contractDetail'
import auth from '@/auth/index'
export default {
  name: 'Index',
  components: {
    deployContract,
    updateContract,
    editContract,
    contractDetail
  },
  filters: {
    transStatus: function(value, defaultVal) {
      if (value == 0) {
        return '投票中'
      } else if (value == 1) {
        return '正常'
      } else if (value == 2) {
        return '拒绝'
      } else if (value == 3) {
        return '失败'
      } else {
        return defaultVal
      }
    },
    transStatusClass: function(value) {
      if (value == 0) {
        return 'is-voting'
      } else if (value == 1) {
        return 'is-success'
      } else if (value == 2) {
        return 'is-rejected'
      } else if (value == 2) {
        return 'is-failed'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      inputContent: '',
      btnList: [
        {
          btnContent: '部署合约',
          click: () => {
            return this.deploy()
          },
          icon: 'icon-deploy',
          auth: auth.blockchain.checkDetail.contractManage.deployContract
        },
        {
          isFill: true
        },
        {
          btnContent: '刷新',
          click: () => {
            return this.handleRefresh()
          },
          type: 'default',
          icon: 'icon-refresh'
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'name',
          label: '合约名称',
          minWidth: 180
        },
        {
          prop: 'version',
          label: '当前版本',
          minWidth: 133
        },
        {
          prop: 'org_id',
          label: '所属组织',
          minWidth: 116
        },
        {
          prop: 'ContractOperator',
          label: '创建者',
          minWidth: 116
        },
        {
          prop: 'updateAt',
          label: '更新时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 158
        },
        {
          prop: 'MultiSignStatus',
          label: '投票状态',
          slotName: 'status',
          minWidth: 132
        },
        {
          prop: 'ContractStatus',
          label: '链上状态',
          formatter: row => {
            return this.chainStatus(row.ContractStatus)
          },
          minWidth: 175
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '冻结',
          click: (row, col, cellValue) => {
            return this.freeze(row)
          },
          icon: 'icon-freeze',
          formatter: row => {
            return this.judgeShow(row, [1, 3, 4, 5, 6, 9, 10])
          },
          class: 'operate-danger'
        },
        {
          text: '解冻',
          click: (row, col, cellValue) => {
            return this.thaw(row)
          },
          icon: 'icon-unfreeze',
          formatter: row => {
            return this.judgeShow(row, [7, 8])
          }
        },
        {
          text: '注销',
          click: (row, col, cellValue) => {
            return this.logout(row)
          },
          icon: 'icon-logout',
          formatter: row => {
            return this.judgeShow(row, [1, 3, 4, 5, 6, 7, 8, 9, 10])
          },
          class: 'operate-danger'
        },
        {
          text: '升级',
          click: (row, col, cellValue) => {
            return this.update(row)
          },
          icon: 'icon-update',
          formatter: row => {
            return this.judgeShow(row, [3, 4, 5, 6, 9, 10])
          }
        },
        {
          text: '编辑',
          click: (row, col, cellValue) => {
            return this.editContract(row)
          },
          icon: 'icon-apply',
          formatter: row => {
            return this.judgeShow(row, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
          }
        },
        {
          text: '查看',
          click: (row, col, cellValue) => {
            return this.goDetail(row)
          },
          icon: 'icon-check',
          formatter: row => {
            return this.judgeShow(row, [11])
          }
        }
      ],
      operateCol: {
        minWidth: 157
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      },
      //冻结、注销
      freezeForm: {
        chainId: '',
        ContractName: '',
        reason: ''
      },
      unfreezeForm: {
        chainId: '',
        ContractName: '',
        reason: ''
      },
      logoutForm: {
        chainId: '',
        ContractName: '',
        reason: ''
      },
      searchName: ''
    }
  },
  computed: {
    ...mapState({
      list: state => state.chain.chain_contract_list,
      paging: state => state.chain.chain_contract_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getBlockContractLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        contractName: this.searchName,
        chainId: this.$route.query.chainId,
        offset,
        limit
      }
      this.getBlockContractLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleRefresh() {
      const { offset, limit } = this.paging
      this.getList(limit, offset)
    },
    refresh() {
      this.searchName = ''
      this.getList()
    },
    handleSearch(value) {
      this.searchName = value
      this.getList()
    },
    goDetail(row) {
      let data = JSON.parse(JSON.stringify(row))
      this.$refs.contractDetail?.handleOpen(data)
    },
    deploy() {
      this.$refs.deployContracts.handleOpen()
    },
    thaw(row) {
      this.$prompt('请输入解冻原因', '解冻合约', {
        confirmButtonText: '解冻',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入原因'
      })
        .then(({ value }) => {
          this.unfreezeForm.chainId = this.$route.query.chainId
          this.unfreezeForm.ContractName = row.name
          this.unfreezeForm.reason = value
          this.$apis.chain.unfreezeContract(this.unfreezeForm).then(res => {
            this.$message({
              type: 'success',
              message: `${row.name}合约解冻开始投票`
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    freeze(row) {
      this.$prompt('请输入冻结原因', '冻结合约', {
        confirmButtonText: '冻结',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入原因'
      })
        .then(({ value }) => {
          this.freezeForm.chainId = this.$route.query.chainId
          this.freezeForm.ContractName = row.name
          this.freezeForm.reason = value
          this.$apis.chain.freezeContract(this.freezeForm).then(res => {
            this.$message({
              type: 'success',
              message: `${row.name}合约冻结开始投票`
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    logout(row) {
      this.$prompt('请输入注销原因', '注销合约', {
        confirmButtonText: '注销',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入原因'
      })
        .then(({ value }) => {
          this.logoutForm.chainId = this.$route.query.chainId
          this.logoutForm.ContractName = row.name
          this.logoutForm.reason = value
          this.$apis.chain.revokeContract(this.logoutForm).then(res => {
            this.$message({
              type: 'success',
              message: '注销成功'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    judgeShow(row, con) {
      return con.includes(row.ContractStatus) && row.ContractStatus !== 0
    },
    update(row) {
      this.$refs.updateDialog.handleOpen(row)
    },
    editContract(row) {
      this.$refs.editContract.handleOpen(row)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.updateAt)
    },
    voteStatus(status) {
      let statusArr = ['投票中', '正常', '拒绝', '失败']
      return statusArr[status]
    },
    chainStatus(status) {
      let statusArr = [
        '合约初始化',
        '合约升级初始化',
        '合约初始化失败',
        '合约初始化成功',
        '合约升级失败',
        '合约升级成功',
        '合约冻结失败',
        '合约冻结成功',
        '合约解冻失败',
        '合约解冻成功',
        '合约注销失败',
        '合约注销成功'
      ]
      return statusArr[status]
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-contract',
  (
    --block-chain-contract-list-operate-color: #45c2ff,
    --block-chain-contract-list-operate-danger-color: #e95757,
    --block-chain-contract-list-status-voting: #fac20a,
    --block-chain-contract-list-status-success: #55da62,
    --block-chain-contract-list-status-rejected: #45c2ff,
    --block-chain-contract-list-status-failed: #e95757
  ),
  (
    --block-chain-contract-list-operate-color: #45c2ff,
    --block-chain-contract-list-operate-danger-color: #e95757,
    --block-chain-contract-list-status-voting: #fac20a,
    --block-chain-contract-list-status-success: #55da62,
    --block-chain-contract-list-status-rejected: #45c2ff,
    --block-chain-contract-list-status-failed: #e95757
  )
);
.block-chain-contract {
  @include adaptation(
    (
      --block-chain-contract-unavaliable-height: 166px
    )
  );
  --block-chain-contract-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--block-chain-contract-unavaliable-height)
  );
  .btn-list-style {
    width: 100%;
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-contract-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-contract-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-contract-min-height);

        .vote-status {
          &.is-voting {
            color: var(--block-chain-contract-list-status-voting);
          }

          &.is-success {
            color: var(--block-chain-contract-list-status-success);
          }

          &.is-rejected {
            color: var(--block-chain-contract-list-status-rejected);
          }

          &.is-failed {
            color: var(--block-chain-contract-list-status-failed);
          }
        }

        .operate-item {
          color: var(--block-chain-contract-list-operate-color);

          &.operate-danger {
            color: var(--block-chain-contract-list-operate-danger-color);
          }
        }
      }
    }
  }
}
</style>
